import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("REST_URL");
const customspremurl="https://customsprem.gov.tc/";
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblusers, setTblusers] = useState([]);


const [ip, setIp] = useState({address:""});
const [aduser, setAduser] = useState({});
const [dowait, setDowait] = useState({on:false});
const [seluser, setSeluser] = useState({adusername:""});

const [searchcrit, setSearchcrit] = useState({name:'', txt:''});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("AW_USERNAME")==null){
	navigate("../logout");
	return;
	}

getipaddress();


	//qrylabor();
 },[]);

useEffect(() => {
	document.getElementsByName('searchcrit')[0].focus();
	
 },[JSON.stringify(tblusers)]);

useEffect(() => {

	console.log('aduser.AD_USERNAME: '+aduser.AD_USERNAME);//JSON.stringify(webuser)
	if (aduser.AD_USERNAME){
		if (modal.open==false)
			toggleModalsm();
			
		}//end if
	
 },[aduser]);

useEffect(() => {
		getadusers();
 },[searchcrit]);

useEffect(() => {
		getaduser();
 },[seluser.adusername]);



function searchcritChange(e){
	setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if


function getipaddress(){
		
fetch('https://api.ipify.org?format=json',{ method: 'GET' })
  .then(res => res.json())
  .then(res => aftergetipaddress(res) )
  .catch(err => getipaddresserr(err) );	
  
}//end func

function getipaddresserr(err){
setIp((prev)=>{
	return {...prev, address:"0.0.0.0" }
	});
console.log(err);
}//end func


function aftergetipaddress(res){
	
setIp((prev)=>{	
return {...prev, address:res.ip} 
	});

if (tblusers.length<1){
	getadusers();
	}//end if	
}//end func


async function initmd(e){
e.preventDefault();

const confd=window.confirm("reset password for this user?");

if (!confd)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), adusername: seluser.adusername} )
  };		

 await fetch(resturl+'rarlogin/initmd',requestOptions)
      .then(res => res.json())
      .then(res => 	afterinitmd(res) )
      .catch(err => console.log(err));

}//end func

function afterinitmd(res){
let UPDATE_COUNT=0;
if (res.length)	
	UPDATE_COUNT=res[0].UPDATE_COUNT;

if (UPDATE_COUNT>0)
	showsnackbar("done!");
else
	showsnackbar("failed!");
}//end func

async function getadusers(){

const crit=searchcrit.name=='custype'?'':searchcrit.txt.trim();
const custype=searchcrit.name=='custype'?searchcrit.txt.trim():'';

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), crit:crit, custype:custype} )
  };		
setAduser({});
 await fetch(resturl+'rarlogin/getadusers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetadusers(res) )
      .catch(err => console.log(err));

}//end func


function trustthisdevice(e){
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {AD_USERNAME:aduser.AD_USERNAME, TRUST:"", IP:ip.address} )
  };		

  fetch(customspremurl+'rarlogin/aduserdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertrustthisdevice(res) )
      .catch(err => console.log(err));
	  

	
}//end func

function aftertrustthisdevice(res){
let trustkey='';
if (res.length)
	if (res.length>0)
		if (res[0].TRUST)
			trustkey=res[0].TRUST;
		
if (trustkey=='')
	showsnackbar("sorry, that did not work");
else{
	const itemkey=aduser.AD_USERNAME+"@customsapps.gov.tc";
	localStorage.setItem(itemkey, trustkey);
	showsnackbar("done!");
	}
}//end func

function promptnewuser(e){
const newuser=window.prompt('enter domain username for new user:', '');
if (newuser){
	   const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( {AD_USERNAME:newuser} )
	  };		
	setTblusers([]);
	  fetch(resturl+'rarlogin/addaduser',requestOptions)
		  .then(res => res.json())
		  .then(res => 	afteraddnewuser(res) )
		  .catch(err => console.log(err));	
	}
}//end func

function afteraddnewuser(res){
	let success=false;
	if (res.length)
		if (res.length==1){
			success=true;
			setAduser((prev)=>{return {...prev, AD_USERNAME:res[0].AD_USERNAME}} );
			}//end if
	
	if (!success)
		showsnackbar("that seems to have failed.  please try again");
}//end func

async function getaduser(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {AD_USERNAME:seluser.adusername} )
  };		

 await fetch(resturl+'rarlogin/getaduser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetaduser(res) )
      .catch(err => console.log(err));

}//end func





function updateaduser(){

const params={
USERNAME : sessionStorage.getItem("AW_USERNAME")
, aduser : aduser
	
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  fetch(resturl+'rarlogin/updateaduser',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateaduser(res) )
      .catch(err => console.log(err));

}//end func

function afterupdateaduser(res){
	if (res.length==undefined)
		showsnackbar('something went wrong, please try again');
	else
		showsnackbar('changes were saved successfully');
	
	if (document.getElementById("btninitmd").classList.contains("hidden"))
		document.getElementById("btninitmd").classList.remove("hidden");
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function aftergetaduser(res){
if (res.length==undefined)
	return;

let datas={};

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
setAduser(datas);

}//end func

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


function aftergetadusers(res){
	
	
if (res.length==undefined)
	return;
	
console.log('aftergetadusers, res.length: '+res.length);


let htmrows=[];
res.map((col, index) => {
	const AD_USERNAME=col['AD_USERNAME'];
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='center' >{col['AD_USERNAME']}</td>
	<td align='center' >{col['AW_USERNAME']}</td>
	<td align='center' >{col['IRD_LOGIN_ID']}</td>
	<td align='center' >{col['EMAIL']}</td>
	<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); setSeluser({adusername:AD_USERNAME});}}><img src="img/folderyel.png"  height='18'  border="0" /> {col['FULL_NAME']}</a></td>
	<td align='center' >{col['MODIFY_DATE']}</td>
	<td align='center' >{col['MODIFY_USER']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});

setTblusers(htmrows);
}//end func




function aduserChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setAduser((prev) => {
return {...prev, [name]:value}
});	
}//end func



const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
	
const AD_USER=sessionStorage.getItem("AD_USERNAME");
	
  return (
    <>
	
<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
search criteria:&nbsp;<input name='searchcrit' defaultValue={searchcrit.text} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='username or email address' />

<button className="button" onClick={(e)=>{promptnewuser(e);}} >add new user</button>

</div>
	
	<table align='center' className='customers' style={{width:"75%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>TCIG username</th>
		<th>Asycuda username</th>
		<th>SIGTAS username</th>
		<th>email</th>
		<th>full name</th>
		<th>Modify Date</th>
		<th>Modify User</th>
	</tr>
	</thead>
	<tbody>
		{tblusers}
	</tbody>
	</table>


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >TCIG Username: </td>
			<td align='left' >
				<input name='AD_USERNAME' size="10" defaultValue={aduser.AD_USERNAME} readOnly className="gnsbro"  />
				&nbsp;&nbsp;<a href="#" id="btninitmd" className="hidden" onClick={(e)=>{initmd(e);}} >reset password</a>
				</td>
			</tr>
			<tr>
			<td align='right' >Email: </td>
			<td align='left' ><input name='EMAIL' value={aduser.EMAIL} onChange={(e)=>{aduserChange(e);}}  /></td>
			</tr>
			<tr>
			<td align='right' >Full Name: </td>
			<td align='left' ><input name='FULL_NAME' value={aduser.FULL_NAME}  onChange={(e)=>{aduserChange(e);}} autoComplete='off' placeholder='full name' /></td>
			</tr>
			<tr>
			<td align='right' >Asycuda Username: </td>
			<td align='left' ><input name='AW_USERNAME' value={aduser.AW_USERNAME}  onChange={(e)=>{aduserChange(e);}} autoComplete='off' placeholder='Asycuda username' /></td>
			</tr>
			<tr>
			<td align='right' >Voucher User: </td>
			<td align='left' ><input name='IRD_LOGIN_ID' value={aduser.IRD_LOGIN_ID}  onChange={(e)=>{aduserChange(e);}} autoComplete='off' placeholder='Voucher User' /></td>
			</tr>

			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{updateaduser(e);}} >update this user</button>}
			</td>
			</tr>

			{
/*
				AD_USER==aduser.AD_USERNAME && 
			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			<button className="button" id='btntrustdevice' onClick={(e)=>{trustthisdevice(e);}} >trust this device</button>
			</td>
			</tr>

*/
			}

	
			<tr>
			<td align='right' >last modified:</td>
			<td align='left' >
			 {aduser.MODIFY_USER+" "+aduser.MODIFY_DATE}
			</td>
			</tr>	
			
			
			</tbody>
			</table>
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;